import Quill from "quill";
import { toTranslit, transliterateString } from "../util/Transliteration";
import { translitLang } from "../SystemState";
import { addKeyboardBinding } from "../util/ui/Keyboard";
export function setupTranslitToolbar(editor) {
    function getAccusativeName(lang) {
        if (locale == "en")
            return lang.displayName;
        if (locale == "ru")
            return lang.displayName.toLowerCase();
        return lang.displayName.toLowerCase().replace(/a$/, "у");
    }
    document.getElementById("toTranslitBtn").onclick = () => transformSelectedText(toTranslit);
    const toLangBtn = document.getElementById("toLangBtn");
    toLangBtn.onclick = () => transformSelectedText(transliterateString);
    updateToLangBtnText();
    addKeyboardBinding({ code: "KeyT", altKey: true }, () => transformSelectedText(transliterateString));
    addKeyboardBinding({ code: "KeyT", altKey: true, shiftKey: true }, () => transformSelectedText(toTranslit));
    translitLang.observe(updateToLangBtnText);
    function updateToLangBtnText() {
        toLangBtn.textContent = strings.toLang + getAccusativeName(translitLang.value);
        toLangBtn.title = `${strings.convertTextToLang + getAccusativeName(translitLang.value)} (Alt+T)`;
    }
    function transformSelectedText(transform) {
        const Delta = Quill.import("delta");
        const selection = editor.getSelection(true);
        const text = editor.getText(selection.index, selection.length);
        const format = editor.getFormat(selection);
        editor.updateContents(new Delta()
            .retain(selection.index)
            .delete(selection.length)
            .insert(transform(text, translitLang.value), format));
    }
}
